export function BrandHeader() {
  return (
    <header className="brandbar">
      <div className="brandmark" aria-label="Aigle">
        <img src="assets/aigle-logo.png" alt="Logo Aigle" />
      </div>

      <div className="brandbar__message">
        {/* <span className="brandbar__pill">TOUT-EN-UN</span>
        <span className="brandbar__arabic" dir="rtl">الكل في واحد</span> */}
      </div>

      <div className="operator-hint" aria-hidden="true">Ctrl + Alt + O</div>
    </header>
  );
}
